'use client';

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface BreadcrumbsProps {
  data?: {
    heading?: {
      title?: string
    }
  }
}

export default function Breadcrumbs({ data }: BreadcrumbsProps) {
  const pathname = usePathname()
  
  if (!pathname) return null;

  const paths = pathname.split('/').filter(Boolean)

  // Function to format path text
  const formatPathText = (path: string) => {
    // Remove any numbers and hyphens from the end of the path
    const cleanPath = path.replace(/-?\d+$/, '').replace(/-+$/, '')
    
    // Split by hyphens and format each word
    return cleanPath.split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }

  return (
		<div className='Breadcrumbs w-full bg-neutral-200 py-6'>
			<div className='container'>
				<nav className='flex flex-wrap items-center gap-1 md:gap-2 text-base font-light font-aileron md:leading-normal leading-tight'>
					<Link
						href='/'
						className='text-gray-slate hover:text-primary transition-colors no-underline'
					>
						Home
					</Link>
					{paths.map((path, index) => {
						const url = `/${paths.slice(0, index + 1).join('/')}`
						const formattedText = formatPathText(path)

						return (
							<div key={path} className='flex items-center gap-2'>
								<span className='text-gray-slate'>/</span>
								{index === paths.length - 1 ? (
									<span className='text-gray-slate'>{formattedText}</span>
								) : (
									<Link
										href={url}
										className='text-gray-slate hover:text-primary transition-colors no-underline'
									>
										{formattedText}
									</Link>
								)}
							</div>
						)
					})}
				</nav>
			</div>
		</div>
	)
}